module.exports = __webpack_public_path__ + "static/media/thumb.a34b1461.jpg";